// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Cj-z","title":"Dj-z","cta":"Ej-z","disabled":"Fj-z"};